var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.9896C8 18.5078 8.18653 18.9637 8.58031 19.3575L25.0155 35.4198C25.3679 35.7927 25.8238 35.9792 26.3627 35.9792C27.4404 35.9792 28.2694 35.171 28.2694 34.0933C28.2694 33.5543 28.0414 33.0984 27.7098 32.7461L12.6218 17.9896L27.7098 3.23316C28.0414 2.88082 28.2694 2.40414 28.2694 1.88601C28.2694 0.808289 27.4404 0 26.3627 0C25.8238 0 25.3679 0.186528 25.0155 0.538859L8.58031 16.6217C8.18653 16.9948 8 17.4715 8 17.9896Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2694,
    height: 36,
    fill: "white",
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.d324351da6adc7affe9732d26e079587.svg";
export { ForwardRef as ReactComponent };